import axios from 'axios'

// eslint-disable-next-line import/no-mutable-exports
const configSettings = {
	siteName: 'Stan',
	nodeEnvironment: process.env.NODE_ENV,
	adminUrl: process.env.VUE_APP_ADMIN_URL,
	pythonApi: process.env.VUE_APP_API,
	defaultStoreUri: process.env.VUE_APP_STORE_URL,
	experimentPriceId: process.env.VUE_APP_STAN_EXPERIMENT_PRICE_ID,
	experimentPrice: process.env.VUE_APP_STAN_EXPERIMENT_PRICE,
	environment: process.env.VUE_APP_ENV_NAME,
	stanAnalyticsUrl: process.env.VUE_APP_STAN_ANALYTICS_URL,
	stanAnalyticsApiUrl: process.env.VUE_APP_STAN_ANALYTICS_API_URL,
	stanCookieBannerUrl: process.env.VUE_APP_STAN_COOKIE_BANNER_URL,
}
axios.defaults.baseURL = configSettings.pythonApi
// eslint-disable-next-line import/prefer-default-export
export { configSettings }
